import React from "react";
import { capitalizeName } from "helper/appConstant";
import { useLoginData } from "./common/loginData";

const UserNameHeader = () => {
  const userData = useLoginData();
  const fullName = userData?.name ? capitalizeName(userData.name) : "";

  const nameParts = userData?.name.split(" ");
  const firstLetter = nameParts?.[0]?.charAt(0).toUpperCase(); // First letter of the first name
  const lastLetter = nameParts?.[1]?.charAt(0).toUpperCase(); // First letter of the last name

  // Combine the first letters of the first and last names
  const initials =
    firstLetter && lastLetter ? `${firstLetter}${lastLetter}` : "";

  return (
    <div className="flex items-center gap-3 mb-8">
      {/* Display initials (IS) */}
      {userData?.profileImageUrl ? (
        <img
          src={userData.profileImageUrl}
          alt="profile"
          className="w-12 h-12 object-cover rounded-full"
        />
      ) : (
        <div
          className="w-12 h-12 bg-highlight text-white
                          flex justify-center items-center
                          font-semibold rounded-full"
        >
          {firstLetter}
        </div>
      )}
      {/* <div className="w-12 h-12 rounded-full bg-[#2BACE2] text-white flex items-center justify-center font-bold text-xl border border-gray-600">
        {initials}
      </div> */}
      {/* Display full name */}
      <span className="text-xl font-normal text-black">{fullName}</span>
    </div>
  );
};

export default UserNameHeader;
